<template>
  <div class="contactus-4 pt-150 pb-500 petit">
    <modal
      :show.sync="modals.modal1"
      modal-classes="modal-dialog-centered modal-xl"
    >
      <h6 slot="header" class="modal-title" id="modal-title-notification">
        Erreur
      </h6>
      <div class="py-3 text-center">
        <i class="ni ni-fat-remove ni-3x"></i>
        <h4 class="heading mt-4">
          Une erreur grave c'est produite ! Veuillez contacter le cabinet au
          05.61.83.29.13 ou réessayer.
        </h4>
        <br />
        <h5>Code Erreur : NO_DATA_RECEIVE</h5>
      </div>
      <template slot="footer">
        <base-button
          type="link"
          text-color="anhod2"
          class="ml-auto"
          @click="modals.modal1 = false"
        >
          Fermer
        </base-button>
      </template>
    </modal>
    <h1 class="hr" id="main">Règlement immédiat du solde</h1>
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <h3><b>Paiement sécurisé</b></h3>
        </div>
      </div>
      <div class="row">
        <div class="col-md-8">
          <div class="bg-anhod3">
            <div class="row pb-1 pt-3" id="montant">
              <div class="col-md-6 pl-5 pb-1">Montant du paiement</div>
              <div class="col-md-2"></div>
              <div class="col-md-4 pr-5" style="text-align: right">
                <spinner
                  class="text-anhod1 mr-2"
                  v-show="spinner.montant"
                ></spinner>
                <a v-show="value.montant">
                  <base-input
                    placeholder="Montant"
                    addonLeftIcon="ni ni-cart"
                    name="section"
                    v-model="data.montant"
                    input-classes="base_input"
                  ></base-input>
                </a>
              </div>
            </div>
            <div class="row pb-1" id="creancier">
              <div class="col-md-6 pl-5 pb-1">Créancier</div>
              <div class="col-md-6 pr-5" style="text-align: right">
                <spinner
                  class="text-anhod1 mr-2"
                  v-show="spinner.client"
                ></spinner>
                <b
                  ><a v-show="value.client">{{ data.client }}</a></b
                >
              </div>
            </div>
          </div>
          <div class="bg-anhod3">
            <div class="row pb-1" id="dossier">
              <div class="col-md-6 pl-5 pb-1">Numéro de dossier</div>
              <div class="col-md-6 pr-5" style="text-align: right">
                <spinner
                  class="text-anhod1 mr-2"
                  v-show="spinner.dossier"
                ></spinner>
                <a v-show="value.dossier">{{ data.dossier }}</a>
              </div>
            </div>
            <div class="row pb-1" id="date">
              <div class="col-md-6 pl-5 pb-1">Date du paiement</div>
              <div class="col-md-6 pr-5" style="text-align: right">
                {{ actual_date }}
              </div>
            </div>
            <div class="row pb-1" id="mail">
              <div class="col-md-6 pl-5 pb-1">
                Adresse mail <a style="color: red;">*</a>
              </div>
              <div class="col-md-6 pr-5" style="text-align: right">
                <base-input
                  placeholder=" Adresse mail"
                  addonLeftIcon="ni ni-email-83"
                  name="section"
                  v-model="mail"
                  input-classes="base_input"
                ></base-input>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-2" id="image">
          <div class="row pt-6">
            <div class="col-md-6" style="text-align: right">
              <br />
              <base-radio
                name="radio3"
                class="mb-3"
                v-model="radio.radio1"
                disabled
              >
              </base-radio>
            </div>
            <div class="col-md-6">
              <img
                src="img/brand/logo_paiement.png"
                alt="logo"
                style="height: 80px;"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="row pt-5" id="btn">
        <div class="col-md-5"></div>
        <div class="col-md-2">
          <base-button
            block
            type="anhod2"
            style="font-size: 1.25em;"
            @click="Validation"
            >Valider</base-button
          >
        </div>
        <div class="col-md-5"></div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import router from "@/router";
import { HTTP_REQUEST } from "../constants/constantes";
import Spinner from "@/components/Spinner";
import Modal from "@/components/Modal";

export default {
  name: "Paiement",
  components: {
    Modal,
    Spinner
  },
  created: function() {
    this.date();
    this.getData();
  },
  data() {
    return {
      actual_date: "",
      mail: "",

      mail_check: false,
      montant_check: false,
      message_erreur_mail: "",
      message_erreur_montant: "",

      radio: {
        radio1: "radio3"
      },
      data: {
        montant: 0,
        client: "",
        dossier: 0
      },
      spinner: {
        montant: true,
        client: true,
        dossier: true
      },
      value: {
        montant: false,
        client: false,
        dossier: false
      },
      modals: {
        modal1: false
      }
    };
  },
  methods: {
    // Création de la date actuelle
    date: function() {
      const today = new Date();
      const ye = new Intl.DateTimeFormat("fr", { year: "numeric" }).format(
        today
      );
      const mo = new Intl.DateTimeFormat("fr", { month: "short" }).format(
        today
      );
      const da = new Intl.DateTimeFormat("fr", { day: "2-digit" }).format(
        today
      );
      this.actual_date = `${da} ${mo.toUpperCase()} ${ye}`;
    },
    // Récupération des informations
    getData: function() {
      if (this.$store.state.tokens != "") {
        const self = this;
        let getDataApi = async function() {
          let action = "action=VuePaiement";
          let token = "&token=" + self.$store.state.tokens;
          var postData = action + token;
          const retourRequete = await axios.post(HTTP_REQUEST, postData);
          return retourRequete;
        };
        getDataApi().then(function(retourApi) {
          if (retourApi.data) {
            if (retourApi.data == "INVALID") {
              self.$store.commit("removeToken", 0);
              self.$store.commit("removeSolde", 0);
              router.push("/login/1/0/0");
            } else if (retourApi.data == "INVALID PARAMS") {
              router.push("/login/1/0/0");
            } else {
              let data = JSON.parse(retourApi.data);
              self.data.dossier = data["data"]["DOSSIER"];
              self.spinner.dossier = false;
              self.value.dossier = true;
              if (self.$store.state.soldes != "") {
                self.data.montant = parseFloat(
                  self.$store.state.soldes[0].replace(",", "")
                );
                self.spinner.montant = false;
                self.value.montant = true;
              }
              if (data["data"]["CLIENT"] != "ERROR_QUERY_2") {
                self.data.client = data["data"]["CLIENT"];
                self.spinner.client = false;
                self.value.client = true;
              }
            }
          } else {
            self.modals.modal1 = true;
          }
        });
      } else {
        router.push("/login/1/0/0");
      }
    },
    // Vérification des saisies et envoi dans le module de paiement
    Validation: function() {
      const char = ";";
      const space = " ";
      this.mail_check = false;
      this.montant_check = false;
      const email = /^(([^<>()[]\.,;:s@]+(.[^<>()[]\.,;:s@]+)*)|(.+))@(([[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}])|(([a-zA-Z-0-9]+.)+[a-zA-Z]{2,}))$/;
      let montant_storage = parseFloat(
        this.$store.state.soldes[0].replace(",", "")
      );
      if (this.data.montant < 1 || this.data.montant > montant_storage) {
        this.message_erreur_montant = "Veuillez entrez un montant valide";
        this.montant_check = true;
        this.$toast.open({
          message: this.message_erreur_montant,
          type: "warning",
          duration: 7500,
          position: "top-right"
        });
      }
      if (this.mail == "") {
        this.message_erreur_mail = "Veuillez renseigner une adresse mail";
        this.mail_check = true;
        this.$toast.open({
          message: this.message_erreur_mail,
          type: "warning",
          duration: 7500,
          position: "top-right"
        });
      } else if (email.test(this.mail) == false) {
        this.message_erreur_mail =
          "Veuillez renseigner une adresse mail valide";
        this.mail_check = true;
        this.$toast.open({
          message: this.message_erreur_mail,
          type: "warning",
          duration: 7500,
          position: "top-right"
        });
      }
      if (this.mail_check == false && this.montant_check == false) {
        if (this.mail.includes(char)) {
          for (let i = 0; i < this.mail.length; i++) {
            if (this.mail[i] == ";") {
              this.mail = this.mail.replace(";", ".");
            }
          }
        }
        if (this.mail.includes(space)) {
          for (let i = 0; i < this.mail.length; i++) {
            if (this.mail[i] == " ") {
              this.mail = this.mail.replace(" ", "");
            }
          }
        }
        let montant = this.data.montant.toString().replaceAll(",", "");
        window.location.href =
          "https://www.anhod.com/api_debiteur/paiement_cb_recouvrement.php?dossier=" +
          this.data.dossier +
          "&montant=" +
          montant +
          "&mail=" +
          this.mail;
      }
    }
  }
};
</script>

<style scoped>
.petit {
  background-image: url("/img/brand/background.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 200%;
  background-attachment: fixed;
  padding-block-end: 20rem;
}
.hr {
  align-items: center;
  display: flex;
  text-align: center;
  color: #222;
  font-size: 2em;
}

.hr::before,
.hr::after {
  border-top: 0.15em solid;
  content: "";
  flex: 1;
  margin: 0 0.5em;
  color: #b2aa68;
}
@media screen and (max-width: 768px) {
  #main {
    padding-top: 10em;
    font-size: 0.8em;
  }
  #montant {
    font-size: 0.85em;
  }
  #creancier {
    font-size: 0.85em;
  }
  #dossier {
    font-size: 0.85em;
  }
  #date {
    font-size: 0.85em;
  }
  #mail {
    font-size: 0.85em;
  }
  #image {
    visibility: hidden;
  }
  #btn {
    margin-top: -14em;
  }
}
</style>
